import { styled } from 'styled-components';

import { Media } from '../../../theme/Media.tsx';
import { Textarea } from '../Textarea/index.tsx';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media ${Media.xsMax} {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

interface StyledTextareaProps {
  height: number;
}

export const StyledTextarea = styled(Textarea)<StyledTextareaProps>`
  @media ${Media.smMin} {
    height: ${({ height }) => `${height}px`};
  }

  @media ${Media.xsMax} {
    min-height: ${({ height }) => `${height}px`};
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 8px;

  & > :first-child {
    flex-grow: 1;
  }
`;
